import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, useLocation } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from './theme/ThemeProvider';
import { SnackbarProvider } from 'notistack';

const ScrollToTop = () => {
    const { pathname } = useLocation();
    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <HelmetProvider>
        <BrowserRouter>
            <ThemeProvider>
                <SnackbarProvider maxSnack={3} autoHideDuration={4000}>
                    <ScrollToTop />
                    <App />
                </SnackbarProvider>
            </ThemeProvider>
        </BrowserRouter>
    </HelmetProvider>
);

reportWebVitals();
